<template>
  <div id="content">
    <div class="basicInformation">
      <div class="typeArea">
        <h2 class="title">商标申请信息</h2>
        <el-form label-width="100px" label-position="left" :model="formLabelAlign" :rules="rules">
          <el-form-item label="申请号/注册号" style="display: block" prop="caseNumber">
            <el-input
              v-model="formLabelAlign.caseNumber"
              placeholder="请输入商标申请号"
              style="position: relative;"
            ></el-input>
            <el-button
              style="position: absolute; right: -40px; top: 3px; height: 35px; line-height: 11px; border-radius: 0px"
              type="primary"
              @click="query"
            >查询</el-button>
          </el-form-item>
          <el-row style="display: flex; flex-wrap:wrap;">
            <el-col>
              <el-form-item :label="`商标图样`">
                <img :src="formLabelAlign.type" alt style="width: 50px" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-col :span="24">
            <el-form-item :label="`商标类别`">
              <el-input
                v-model="formLabelAlign.brandType"
                :placeholder="`请输入商标类别`"
                :disabled="true"
              ></el-input>
              <el-button
                style="position: absolute; right: -40px; top: 3px; height: 35px; line-height: 11px; border-radius: 0px"
                type="primary"
                @click="dialogVisible = true"
              >分类</el-button>
              <!-- <el-dialog
                title="提示"
                :visible.sync="dialogVisible"
                width="30%"
                :before-close="handleClose"
              >
                <span>这是一段信息</span>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="dialogVisible = false">取 消</el-button>
                  <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
                </span>
              </el-dialog>-->
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="`申请人名称`">
              <el-input v-model="formLabelAlign.applicantName" :placeholder="`请申请人名称`"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="`统一社会信用代码`">
              <el-input v-model="formLabelAlign.assistant" :placeholder="`请输入统一社会信用代码`"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="`商标代理机构名称`">
              <el-input v-model="formLabelAlign.agent" :placeholder="`请输入商标代理机构名称`"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
    </div>
    <div class="rejectionInformation">
      <div class="typeArea">
        <h2 class="title">商标驳回信息</h2>
        <el-form label-width="100px" label-position="left" :model="formLabelAlign" :rules="rules">
          <el-form-item label="收到通知书日期" required>
            <el-col :span="20">
              <el-form-item prop="date1">
                <el-date-picker
                  type="date"
                  placeholder="请选择收到驳回通知书日期"
                  v-model="formLabelAlign.date1"
                  style="width: 100%;"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
              <el-tooltip class="item" effect="dark" content="Right Center 提示文字" placement="right">
                <img src="@/assets/imgs/brandReview/putRecord/次级提醒 copy 2.png" alt />
              </el-tooltip>
            </el-col>
          </el-form-item>
          <el-row style="display: flex; flex-wrap:wrap;">
            <el-col :span="10">
              <el-form-item label="收到通知方式" :rules="[{ required: true,trigger: 'blur' }]">
                <el-radio v-model="formLabelAlign.radio" label="电子版">电子版</el-radio>
                <el-radio v-model="formLabelAlign.radio" label="纸质版">纸质版</el-radio>
                <el-tooltip class="item" effect="dark" content="请选择收到通知的方式" placement="right">
                  <img
                    src="@/assets/imgs/brandReview/putRecord/次级提醒 copy 2.png"
                    alt
                    style="height:29px; position: relative; left: -20px"
                  />
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
          <el-col :span="10">
            <el-form-item :label="`商标驳回通知书`" required>
              <el-upload
                class="upload-demo"
                :action="pdfUploadUrl"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                multiple
                :before-upload="beforeAvatarUpload"
                :file-list="fileList"
                :http-request="fileUploadTxt"
              >
                <el-button size="small">上传</el-button>
                <div slot="tip" class="el-upload__tip">1、电子版请上传驳回通知书原件；</div>
                <div slot="tip" class="el-upload__tip">2、纸质版驳回通知书请上传扫描件；</div>
                <div slot="tip" class="el-upload__tip" style="margin-bottom: 20px">3、文件格式为PDF。</div>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="`知识产权局发文号`" prop="postNo">
              <el-input
                v-model="formLabelAlign.postNo"
                :placeholder="`请输入知识产权局发文号`"
                style="width: 83%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="`引证商标`" :rules="[{required: true}]">
              <el-upload
                class="upload-demo"
                :action="pdfUploadUrl"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                multiple
                :before-upload="beforeAvatarUpload"
                :file-list="fileList"
                :http-request="fileUploadTrademark"
              >
                <el-button size="small">上传</el-button>
                <div slot="tip" class="el-upload__tip">1、被驳回商标有引证商标的必须上传；</div>
                <div slot="tip" class="el-upload__tip">2、电子版请上传引证商标原件；</div>
                <div slot="tip" class="el-upload__tip">3、纸质版引证商标请上传扫描件；</div>
                <div
                  slot="tip"
                  class="el-upload__tip"
                  style="margin-bottom: 20px"
                >4、文件格式为PDF，可上传多个文件。</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-form>
      </div>
    </div>
    <div class="footer">
      <div class="matter">
        <div class="num">
          <span>应付金额：</span>
          <i>￥</i>
          <span class="price">{{product.price}}</span>
        </div>
        <el-button @click="creatOrder(),changeReview(),changeProductList()">立即下单</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { getOss } from "@/api/tmTools.js";
import {
  enquiryNumber, //商标号查询
  getProductListCards, //获取商品列表
  SCCode, //统一信用代码查询
  getRejContent, //根据驳回通知书获取内容(知识产权局发文号)
  getNcList, //尼斯二级分类
  createReviewOrder, //创建订单
} from "@/api/fill.js";
import { mapState } from "vuex";
export default {
  data() {
    return {
      queryData: {},
      dialogVisible: false,
      product: {},
      key: "",
      data: "",
      pdfUploadUrl: "",
      fileList: [],
      checked: [],
      formLabelAlign: {
        trademarkUrl: "",
        applicationUrl: "",
        radio: "电子版",
        date1: "", //收到通知书日期
        type: "", //商标图样
        caseNumber: "", //申请号/注册号
        agent: "", //  商标代理机构名称
        applicantName: "", //申请人名称
        assistant: "", //统一社会信用代码
        brandType: "", //商标类别
        postNo: "", //知识产权局发文号
        price: "", //应付金额
        rejData: {}, //根据驳回通知书返回的数据
        nclexist: [], //小类
      },
      rules: {
        caseNumber: [
          { required: true, message: "请输入申请号/注册号", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 10 个字符",
            trigger: "blur",
          },
        ],
        date1: [
          { required: true, message: "请输入收到通知书日期", trigger: "blur" },
        ],
        postNo: [
          {
            required: true,
            message: "请输入知识产权局发文号",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      reviewInfo: (state) => state.brandReview.reviewInfo,
      productList: (state) => state.brandReview.productList,
    }),
  },
  created() {
    let params = "sbfu/zzsbfs";
    getProductListCards(params).then((res) => {
      if (res.status == 0) {
        this.product = res.data[0] || {};
      } else if (res.status == -99) {
        window.localStorage.setItem("url", window.location.hash.split("#")[1]);
        this.$router.push("/user/login");
      } else {
        this.$message("请刷新页面重试!");
      }
    });

    getOss().then((res) => {
      if (res.status == 0) {
        this.data = res.data;
        this.data.key = this.setKey();
        this.pdfUploadUrl = res.data.url;
      }
    });
  },
  mounted() {
    this.$store.commit("qffillmaterials/changeActivedIndex", 0);
  },
  beforeRouteEnter(to, from, next) {
    // 路由导航钩子，此时还不能获取组件实例 `this`，所以无法在data中定义变量（利用vm除外）
    // 所以，利用路由元信息中的meta字段设置变量，方便在各个位置获取。这就是为什么在meta中定义isBack
    if (from.name == "applicantInformation") {
      to.meta.isBack = true;
      //判断是从哪个路由过来的，
      //如果是detailpay或者spdetail过来的，表明当前页面不需要刷新获取新数据，直接用之前缓存的数据即可
    }
    next();
  },
  methods: {
    handleClose(done) {},
    //申请号查询
    query() {
      let params = {
        regNum: this.formLabelAlign.caseNumber, //注册号
        sqlbtabkey: "", //申请类别
        flzttabkey: "", //法律状态
        sqnftabkey: "", //申请年份
        xcl: [], //商标群组
        pageSize: 20, //每页数量
        currentPage: 1, //当前页
      };
      if (this.formLabelAlign.caseNumber) {
        enquiryNumber(params).then((res) => {
          if (res.status == 0) {
            if (res.data.rows.length != 0) {
              let queryData = res.data.rows;
              this.formLabelAlign.type = queryData[0].logo; //商标
              this.formLabelAlign.applicantName = queryData[0].zcr;
              this.formLabelAlign.agent = queryData[0].dljg; //商标代理机构
              this.formLabelAlign.brandType = queryData[0].gjfl; //尼斯一级大类
              // 获取二级尼斯分类
              let params = {
                sbzch: this.formLabelAlign.caseNumber, //商标申请号
                gjfl: this.formLabelAlign.brandType, //申请类别
              };
              getNcList(params).then((res) => {
                if (res.status == 0) {
                  this.formLabelAlign.nclexist = res.data.nclexist;
                }
              });
              // 统一信用代码查询
              let paramSC = {
                company_name: this.formLabelAlign.applicantName,
              };
              SCCode(paramSC).then((res) => {
                if (res.status == 0) {
                  this.formLabelAlign.assistant = res.data.creditCode;
                } else {
                  this.formLabelAlign.assistant = "";
                }
              });
            } else {
              this.$message({
                message: "申请号/注册号有误，请核对后，重新输入",
                type: "warning",
              });
              this.formLabelAlign.type = ""; //商标
              this.formLabelAlign.applicantName = ""; //申请人名称
              this.formLabelAlign.brandType = ""; //商标类别
              this.formLabelAlign.agent = ""; // 商标代理机构
              this.formLabelAlign.assistant = ""; // 统一信用代码
            }
          }
        });
      } else {
        this.$message({ message: "申请号/注册号 不能为空", type: "warning" });
      }
    },
    // 立即下单
    creatOrder() {
      if (!this.formLabelAlign.caseNumber) {
        this.$message({ message: "申请号/注册号 不能为空", type: "warning" });
      } else if (!this.formLabelAlign.applicantName) {
        this.$message({ message: "申请人名称不能为空", type: "warning" });
      } else if (!this.formLabelAlign.assistant) {
        this.$message({ message: "统一信用代码不能为空", type: "warning" });
      } else if (!this.formLabelAlign.agent) {
        this.$message({ message: "商标代理机构名称不能为空", type: "warning" });
      } else if (!this.formLabelAlign.date1) {
        this.$message({ message: "收到通知书日期不能为空", type: "warning" });
      } else if (!this.formLabelAlign.applicationUrl) {
        this.$message({ message: "请上传商标驳回通知书", type: "warning" });
      } else if (!this.formLabelAlign.trademarkUrl) {
        this.$message({ message: "请上传引证商标", type: "warning" });
      } else {
        this.addOrder()
      }
    },
    // 修改vuex中的信息
    changeReview() {
      this.formLabelAlign.price = this.product.price;
      this.$store.commit("brandReview/changeReview", this.formLabelAlign);
    },
    changeProductList() {
      this.$store.commit("brandReview/changeProductList", this.product);
    },
    // 上传
    pdfUpload(file) {
      this.fileUploadTxt(file, "pdf");
      console.log(file);
    },
    // 上传商标驳回通知书
    fileUploadTxt(file, type) {
      this.$message("上传中...");
      // 此时可以自行将文件上传至服务器
      let data = new FormData();
      data.append("Bucket", this.data.Bucket);
      data.append("OSSAccessKeyId", this.data.OSSAccessKeyId);
      data.append("Signature", this.data.Signature);
      data.append("key", this.setKey());
      data.append("policy", this.data.policy);
      data.append("success_action_status", this.data.success_action_status);
      data.append("url", this.data.url);
      data.append("file", file.file);
      axios.post(this.data.url, data).then((res) => {
        if (res.status == "201") {
          var doc = new DOMParser().parseFromString(res.data, "text/xml");
          let url = doc.getElementsByTagName("Location")[0].innerHTML;
          this.formLabelAlign.applicationUrl = url;
          //   console.log(url, "plpplplp");
          this.$message("上传成功");
          //根据驳回通知书获取内容
          let params = this.formLabelAlign.applicationUrl;
          getRejContent(params).then((res) => {
            if (res.status == 0) {
              this.formLabelAlign.rejData = res.data;
              this.formLabelAlign.postNo = res.data.msg_number;
              //   console.log(this.formLabelAlign.rejData, "77777777777");
            }
          });
        }
      });
    },
    // 上传
    pdfUpload(file) {
      this.fileUploadTrademark(file, "pdf");
      console.log(file);
    },
    // 上传引证商标
    fileUploadTrademark(file, type) {
      this.$message("上传中...");
      // 此时可以自行将文件上传至服务器
      let data = new FormData();
      data.append("Bucket", this.data.Bucket);
      data.append("OSSAccessKeyId", this.data.OSSAccessKeyId);
      data.append("Signature", this.data.Signature);
      data.append("key", this.setKey());
      data.append("policy", this.data.policy);
      data.append("success_action_status", this.data.success_action_status);
      data.append("url", this.data.url);
      data.append("file", file.file);
      axios.post(this.data.url, data).then((res) => {
        if (res.status == "201") {
          var doc = new DOMParser().parseFromString(res.data, "text/xml");
          let url = doc.getElementsByTagName("Location")[0].innerHTML;
          this.formLabelAlign.trademarkUrl = url;
          console.log(url, "plpplplp");
          this.$message("上传成功");
        }
      });
    },
    //随机key
    setKey() {
      // name = name.substring(name.length - 5);
      var myDate = new Date();
      var key =
        "zc_" +
        Math.round(Math.random() * 10000) +
        myDate.getTime() +
        myDate.getFullYear() +
        myDate.getMonth() +
        myDate.getDate() +
        ".pdf";
      // this.$refs[flag].data.key = key;
      return key;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    beforeAvatarUpload(file) {
      const isPDF = file.type === "application/pdf";
      if (!isPDF) {
        this.$message.error("上传文件只能是 PDF 格式!");
      }
      return isPDF;
    },
    // 创建订单
    addOrder() {
      let params = {
        channelItemCode: this.product.channel_item_code,
        channelItemAppendName: this.product.channel_item_name,
        payCode: this.product.pay_code,
        quantity: 1,
        totalSum: this.product.price,
        payTotalSum: this.product.price * 1,
        notes: "",//订单备注信息
        orderContact: {},//联系人信息
        channelOrder: {},//渠道订单
        deliveryData: {
          apply: {
            askforId: this.formLabelAlign.caseNumber,
            tradeImg: this.formLabelAlign.type,
            tradeType: this.formLabelAlign.brandType,
            applicantName: this.formLabelAlign.applicantName,
            usccode: this.formLabelAlign.assistant,
            agentName: this.formLabelAlign.agent,
          },
          applyUser: {},//申请人信息
          trademarkRejInfo: {
            noticeDate: this.formLabelAlign.date1,
            noticeMode: this.formLabelAlign.radio,
            zhichanNumber: this.formLabelAlign.postNo,
            rejNotice: this.formLabelAlign.applicationUrl,
            quotedTrademark: this.formLabelAlign.trademarkUrl,
          },
          askForData: {},//证据材料
          supData: {},//补充材料
        },
      };
      createReviewOrder(params).then((res) => {
        if (res.status == 0) {
          this.$router.push({path: "/brandReview/selfHelp/applicantInformation",});
          let orderInfo = {
              payNo: res.data.channelOrderNo,
              payMoney: this.product.price,
              serveItem: this.product.channel_item_name,
           }
          this.$store.commit("brandReview/changeOrderInfo",orderInfo);
        } else if (res.status == -99) {
          window.localStorage.setItem(
            "url",
            window.location.hash.split("#")[1]
          );
          this.$router.push("/user/login");
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#content {
  width: 100%;
  padding-bottom: 10px;
  overflow: hidden;
  background-color: #f4f4f4;
  .basicInformation {
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80%;
    background-color: #fff;
    border: 1px solid #ddd;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
    .typeArea {
      width: 80%;
      .title {
        white-space: nowrap;
        font-size: 18px;
        font-weight: 900;
        height: 100%;
        margin-top: 30px;
      }
      .el-form {
        margin-top: 20px;
        margin-left: 20px;
        /deep/.el-form-item {
          display: inline-block;
          white-space: nowrap;
          width: 100%;
          margin-bottom: 12px;
          .el-form-item__error {
            margin-left: 40px;
            margin-top: 5px;
          }
          .el-form-item__label {
            margin-right: 40px;
          }
          .el-form-item__content {
            height: 30px;
            width: 60%;
            .el-input {
              display: inline-block;
              width: 100%;
              height: 35px;
              .el-input__inner {
                border-radius: 0px;
                display: inline-block;
                width: 100%;
                height: 35px;
              }
            }
          }
        }
        .demonstration {
          margin-right: 45px;
        }
        .el-date-editor {
          width: 62%;
          height: 40px;
        }
        /deep/.el-radio__inner {
          border-color: #bbb;
        }
        /deep/.el-input__inner {
          width: 102%;
          height: 35px;
          line-height: 35px;
          border-radius: 0px;
        }
        /deep/.el-input__icon {
          line-height: 35px;
        }
        /deep/.el-picker-panel .el-date-picker .el-popper {
          position: absolute;
          top: 509px;
        }
      }
    }
  }
  .rejectionInformation {
    margin: 5px auto;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80%;
    background-color: #fff;
    border: 1px solid #ddd;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
    .typeArea {
      width: 80%;
      .title {
        white-space: nowrap;
        font-size: 18px;
        font-weight: 900;
        height: 100%;
        margin-top: 30px;
      }
      .el-form {
        margin-top: 20px;
        margin-left: 20px;
        /deep/.el-form-item {
          position: relative;
          display: inline-block;
          white-space: nowrap;
          width: 100%;
          margin-bottom: 12px;
          .el-form-item__error {
            margin-left: 40px;
            margin-top: -2px;
          }
          .el-form-item__label {
            margin-right: 40px;
            white-space: nowrap;
          }
          img {
            display: inline-block;
            position: relative;
            top: 10px;
            left: -100px;
          }
        }
        .upload-demo {
          margin-left: 40px;
          .el-button {
            border-radius: 0px;
            border: 1px solid #0065ff;
            color: #0065ff;
            width: 90px;
            height: 35px;
          }
          .el-upload__tip {
            color: #aaa;
            height: 20px;
            font-size: 14px;
          }
        }
        .el-input {
          height: 35px;
          width: 100%;
          /deep/.el-input__inner {
            height: 35px;
            border-radius: 0px;
            width: 82%;
          }
        }
      }
    }
  }
  .footer {
    position: relative;
    bottom: -10px;
    width: 100%;
    height: 100px;
    background-color: #fff;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
    .matter {
      position: absolute;
      right: 190px;
      bottom: 22px;
      display: flex;
      align-items: center;
      .num {
        display: inline-block;
        i {
          color: #ff6a01;
        }
        .price {
          font-size: 28px;
          font-weight: 900;
          color: #ff6a01;
        }
      }
      .el-button {
        background-color: #ff6a01;
        font-size: 16px;
        width: 145px;
        height: 44px;
        color: #fff;
        margin-left: 30px;
        border-radius: 0px;
      }
    }
  }
}
</style>